import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from '@feature/_app_modules/layout/layout.module';
import { GridsterDashboardModule } from '@feature/_app_modules/gridster-dashboard/gridster-dashboard.module';
import { TenantParentListPageComponent } from
  '@feature/_app_modules/mojo-dashboard-mci-common/tenant-parent-lister/container/tenant-parent-list-page.component';
import { ManagerListPageComponent } from './manager-list-page/manager-list-page.component';
import { ClientParentListPageComponent } from './client-parent-list-page/client-parent-list-page.component';
import { ClientListPageComponent } from './client-list-page/client-list-page.component';
import { EstateListPageComponent } from './estate-list-page/estate-list-page.component';
import { PropertyListPageComponent } from './property-list-page/property-list-page.component';
import { HeadleaseListPageComponent } from './headlease-list-page/headlease-list-page.component';
import { LandlordListPageComponent } from './landlord-list-page/landlord-list-page.component';
import { UnitListPageComponent } from './unit-list-page/unit-list-page.component';
import { LeaseListPageComponent } from './lease-list-page/lease-list-page.component';
import { TenantListPageComponent } from './tenant-list-page/tenant-list-page.component';
import { DebtorListPageComponent } from './debtor-list-page/debtor-list-page.component';
import { CreditorListPageComponent } from './creditor-list-page/creditor-list-page.component';
import { VacantListPageComponent } from './vacant-list-page/vacant-list-page.component';
import { SupplierListPageComponent } from './supplier-list-page/supplier-list-page.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GridsterDashboardModule,
    LayoutModule
  ],
  declarations: [
    TenantParentListPageComponent,
    ManagerListPageComponent,
    ClientParentListPageComponent,
    ClientListPageComponent,
    EstateListPageComponent,
    PropertyListPageComponent,
    HeadleaseListPageComponent,
    LandlordListPageComponent,
    UnitListPageComponent,
    LeaseListPageComponent,
    TenantListPageComponent,
    DebtorListPageComponent,
    CreditorListPageComponent,
    VacantListPageComponent,
    SupplierListPageComponent
  ],
  exports: [
    TenantParentListPageComponent
  ]
})
export class MojoDashboardMciCommonModule { }

